// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-xlg {
  font-size: 32px;
}

.font-lg {
  font-size: 22px;
}

.font-mdlg {
  font-size: 18px;
}

.font-md {
  font-size: 14px;
}

.font-sm {
  font-size: 12px;
}

.form-sm label.title {
  font-size: 1rem;
  margin: 0 0 11px 0;
  font-family: Inter, sans-serif;
}

.fw-600 {
  font-weight: 600;
}

.font-size-h4 {
  font-size: 23.5px;
}

.options {
  padding-left: 7px;
  padding-right: 7px;
}

button {
  background-color: transparent;
  border: none;
  color: #00709e;
}
button.circle {
  background-color: white;
  border: 1px solid #ccc;
}
button.transparent {
  background-color: transparent;
}

.options-button {
  border-radius: 50%;
  width: 38px;
  cursor: pointer;
}
.options-button.with-label {
  width: auto;
  border: none;
  background-color: transparent;
  padding: 4px 4px 4px 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.options-button.with-label img {
  width: 28px;
  height: 28px;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-color: white;
}

.top-button {
  border-radius: 0.25rem;
  padding-left: 14px;
  padding-right: 14px;
}
.top-button img {
  padding-bottom: 2px;
}

.options-box {
  border: 1px solid grey;
  min-width: 235px;
  width: max-content;
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.3);
  position: absolute;
  background-color: white;
  z-index: 100;
  right: 0;
}
.options-box.circle {
  top: 45px;
}

.topspacing {
  top: 35px;
}

.menu-disabled {
  opacity: 0.5;
  pointer-events: none;
  color: #ccc;
}
.menu-disabled button {
  color: #ccc;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/styles/sizes.scss","webpack://./src/app/components/context-menu/context-menu.component.scss"],"names":[],"mappings":"AAmBA;EACE,eAPS;ACXX;;ADqBA;EACE,eAVQ;ACRV;;ADqBA;EACE,eAbU;ACLZ;;ADqBA;EACE,eAhBQ;ACFV;;ADqBA;EACE,eAnBQ;ACCV;;ADsBE;EACE,eAAA;EACA,kBAAA;EACA,8BAAA;ACnBJ;;ADuBA;EACE,gBAAA;ACpBF;;ADuBA;EACE,iBAAA;ACpBF;;AA7BA;EACE,iBAAA;EACA,kBAAA;AAgCF;;AA7BA;EACE,6BAAA;EACA,YAAA;EACA,cAAA;AAgCF;AA9BE;EACE,uBAAA;EACA,sBAAA;AAgCJ;AA9BE;EACE,6BAAA;AAgCJ;;AA5BA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AA+BF;AA7BE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AA+BJ;AA7BI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;AA+BN;;AA1BA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;AA6BF;AA3BE;EACE,mBAAA;AA6BJ;;AAzBA;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,QAAA;AA4BF;AA3BE;EACE,SAAA;AA6BJ;;AAzBA;EACE,SAAA;AA4BF;;AAzBA;EACE,YAAA;EACA,oBAAA;EACA,WAAA;AA4BF;AA3BE;EACE,WAAA;AA6BJ;AACA,grIAAgrI","sourcesContent":["$min-page-width: 1260px;\n$main-box-width: 1074px;\n$header-height: 80px;\n\n$main-form-circle-font-size: 0.875rem;\n$main-form-title-font-size: 1.125rem;\n$main-form-label-font-size: 1rem;\n\n$dialog-close-x: 22px;\n$dialog-header-title-main-font-size: 2rem;\n$dialog-header-title-font-size: 1.375rem;\n$dialog-header-title-font-size-small: 12px;\n\n$font-xlg: 32px;\n$font-lg: 22px;\n$font-mdlg: 18px;\n$font-md: 14px;\n$font-sm: 12px;\n\n.font-xlg {\n  font-size: $font-xlg;\n}\n\n.font-lg {\n  font-size: $font-lg;\n}\n\n.font-mdlg {\n  font-size: $font-mdlg;\n}\n\n.font-md {\n  font-size: $font-md;\n}\n\n.font-sm {\n  font-size: $font-sm;\n}\n\n.form-sm {\n  label.title {\n    font-size: 1rem;\n    margin: 0 0 11px 0;\n    font-family: Inter, sans-serif;\n  }\n}\n\n.fw-600 {\n  font-weight: 600;\n}\n\n.font-size-h4 {\n  font-size: 23.5px;\n}\n","@import 'sizes';\n@import 'colors';\n\n.options {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n\nbutton {\n  background-color: transparent;\n  border: none;\n  color: #00709e;\n\n  &.circle {\n    background-color: white;\n    border: 1px solid #ccc;\n  }\n  &.transparent {\n    background-color: transparent;\n  }\n}\n\n.options-button {\n  border-radius: 50%;\n  width: 38px;\n  cursor: pointer;\n\n  &.with-label {\n    width: auto;\n    border: none;\n    background-color: transparent;\n    padding: 4px 4px 4px 0;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n\n    img {\n      width: 28px;\n      height: 28px;\n      padding: 6px;\n      border: 1px solid #ccc;\n      border-radius: 50%;\n      background-color: white;\n    }\n  }\n}\n\n.top-button {\n  border-radius: 0.25rem;\n  padding-left: 14px;\n  padding-right: 14px;\n\n  img {\n    padding-bottom: 2px;\n  }\n}\n\n.options-box {\n  border: 1px solid grey;\n  min-width: 235px;\n  width: max-content;\n  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.3);\n  position: absolute;\n  background-color: white;\n  z-index: 100;\n  right: 0;\n  &.circle {\n    top: 45px;\n  }\n}\n\n.topspacing {\n  top: 35px;\n}\n\n.menu-disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  color: #ccc;\n  button {\n    color: #ccc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
